import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
} from "@material-ui/core";

const CommonModalComp = ({
  open,
  onClose,
  onSubmit,
  title,
  contentComponent,
  confirmButtonText = "Submit",
  cancelButtonText = "Cancel",
}) => {
  const handleConfirmClick = () => {
    // Pass any data back to the parent if needed
    onSubmit();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {/* Render the content dynamically */}
        {contentComponent}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {cancelButtonText}
        </Button>
        <Button onClick={handleConfirmClick} color="primary">
          {confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CommonModalComp;
